module.exports = __webpack_public_path__ + "static/media/expBlack.bd167348.svg";